import './contact.css';
import 'components/contact-footer/component.css';

import { hubspotOnFormReady, restyleHubspotForm, resizeIframeByContainer } from '../../ably-ui/hubspot-forms';

document.addEventListener('DOMContentLoaded', () => {
  window.hubspotOnFormReady = hubspotOnFormReady;
});

const hubspotFormHasAppended = () => {
  const handleResize = resizeIframeByContainer('#hs-form-iframe-0', '#contact-form');
  window.addEventListener('resize', handleResize);

  restyleHubspotForm('#hs-form-iframe-0');
};

const observer = new MutationObserver(hubspotFormHasAppended);
observer.observe(document.querySelector('#contact-form'), { childList: true });
